<template>
  <div id="fileupload">
    <label class="btn btn-white">
      <i class="fa fa-paperclip"><input type="file" @change="upload" style="display:none" accept="image/*" /></i>
    </label>
  </div>
</template>
<script>
import AWS from 'aws-sdk'
import uniqid from 'uniqid'

export default {
  name: 'fileupload',
  methods: {
    upload: function(e) {
      var file = e.target.files[0]

      if(!file) return
      if(file.type.indexOf('image') == -1) return

      AWS.config.accessKeyId = process.env.OSS_KEY
      AWS.config.secretAccessKey= process.env.OSS_SECRET
      var spaceEndpoint = process.env.OSS_ENDPOINT
      var bucket = new AWS.S3({
        endpoint: spaceEndpoint
      })

      var fileExt = file.name.substr(-4)
      var filename = uniqid() + fileExt
      var params = {
        Bucket: process.env.OSS_BUCKET_NAME,
        Key: this.type + '/' + this.context + '/' + filename,
        Body: file,
        ContentType: file.type,
        ACL: 'public-read'
      }

      var context = this
      bucket.upload(params, function(error, data) {
        if(error) {
          console.error(error)
        } else {
          context.$emit('uploaded', data.Location)
          context.$emit('uploadedData', data)
        }
      })
    }
  },
  props: {
    accept: String,
    context: String,
    type: {
      type: String,
      default: 'gallery'
    }
  }
}
</script>



// WEBPACK FOOTER //
// FileUpload.vue?02c1da6d